import { PatientChartInfo, State } from 'types';

export const getSelectedChart = (state: State): PatientChartInfo =>
  state.session.activeChartId && state.entities.charts
    ? state.entities.charts[state.session.activeChartId]
    : undefined;

export const getChart = (state: State, { chartId }: { chartId: number }) =>
  state.entities.charts ? state.entities.charts[chartId] : undefined;
